import React from 'react';

import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import {
    TextField,
    Grid,
    Switch,
    FormGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    IconButton,
    Tooltip,
    RadioGroup,
    Radio,
    Divider
} from '@material-ui/core/';
import { Help } from '@material-ui/icons';


import './styles.css';

const TASK_HELPTEXT = 'Selecting multiple will allow your brand fan to decide which format they prefer (recommended)';
const BRIEF_HELPTEXT = 'Keep it short and simple! Limit is 500 characters.';
const GIFT_HELPTEXT = 'If you want to send out a product or a sample, we will provide you with an address list as soon as brand fans subscribe to the campaign.';
const DISCOUNT_HELPTEXT = 'If you want to share a discount code for your product, include it here! Also specify if your code has limited duration or availability';
const HASHTAG_HELPTEXT = 'All posts will have these hashtags and mentions';
const CAMPAIGN_URL = 'This link will be added to the brand fan\'s bio for 5 days and will be tracked for campaign performance';
const VIDEO_PROMOTION_HELPTEXT = 'The video feature is currently in beta, if you would like to try it, please contact your account manager for more details';

export const Instructions = ({ updateValue, values, errors, onChange }) => {
    return (
        <div>
            <div className="campaign-step-header">
                <Typography variant="h5">
                    Instructions
            </Typography>
            </div>
            <Grid container>
                <Grid item xs={12}>
                    <Typography>
                        How you want them to promote your brand?
                        </Typography>
                    <FormControl component="fieldset">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <FormLabel component="legend">Task</FormLabel>
                            <Tooltip title={TASK_HELPTEXT} >
                                <IconButton aria-label="helptext">
                                    <Help />
                                </IconButton>
                            </Tooltip>
                        </div>
                        <FormGroup>
                            <FormControlLabel
                                control={<Checkbox id="promoteByPost" color="primary" checked={values.promoteByPost ? values.promoteByPost : false} onChange={onChange} value="post" />}
                                label="Instagram post"
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox id="promoteByStory" color="primary" checked={values.promoteByStory ? values.promoteByStory : false} onChange={onChange} value="story" />
                                }
                                label="Instagram story"
                            />
                            <div>
                                <FormControlLabel
                                    style={{ marginRight: '2px' }}
                                    control={
                                        <Checkbox id="promoteByVideo" color="primary" checked={values.promoteByVideo ? values.promoteByVideo : false} onChange={onChange} value="video" />
                                    }
                                    label="Instagram Video"
                                />
                                <Tooltip title={VIDEO_PROMOTION_HELPTEXT} >
                                    <IconButton aria-label="helptext">
                                        <Help />
                                    </IconButton>
                                </Tooltip>
                            </div>
                            <div className="chips-error">{errors.promoteByVideo || errors.promoteByPost || errors.promoteByStory ? errors.promoteByStory || errors.promoteByPost || errors.promoteByVideo : ''}</div>
                        </FormGroup>
                    </FormControl>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <FormLabel component="legend">Brief</FormLabel>
                            <Tooltip title={BRIEF_HELPTEXT} >
                                <IconButton aria-label="helptext">
                                    <Help />
                                </IconButton>
                            </Tooltip>
                        </div>

                        <TextField
                            id="brief"
                            label="Brief"
                            value={values.brief}
                            onChange={onChange}
                            fullWidth
                            rows={4}
                            autoFocus
                            multiline
                            margin="normal"
                            variant="outlined"
                            required={true}
                            error={!!errors.brief}
                            helperText={errors.brief ? errors.brief : ''}
                        />

                    </div>
                    <FormControl component="fieldset">
                        <div style={{ display: 'flex' }}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        id="sendGift"
                                        checked={values.sendGift ? values.sendGift : false}
                                        onChange={onChange}
                                        value="checkedB"
                                        color="primary"
                                    />
                                }
                                label="Gift a product?"
                                labelPlacement="start"
                            />
                            <Tooltip title={GIFT_HELPTEXT} >
                                <IconButton aria-label="helptext">
                                    <Help />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </FormControl>
                    <Grid container>
                        <Grid item xs={10}>
                            <TextField
                                id="discountCode"
                                value={values.discountCode ? values.discountCode : ''}
                                onChange={onChange}
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                error={errors.discountCode}
                                label="Discount Code"
                            />
                        </Grid>
                        <Grid item xs={1} className="tooltip-grid-item">
                            <Tooltip title={DISCOUNT_HELPTEXT} >
                                <IconButton aria-label="helptext">
                                    <Help />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={10}>
                            <TextField
                                id="hashtagsAndMentions"
                                value={values.hashtagsAndMentions ? values.hashtagsAndMentions : ''}
                                onChange={onChange}
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                label="Hashtags and mentions"
                                error={errors.discountCode}
                            />
                        </Grid>
                        <Grid item xs={1} className="tooltip-grid-item">
                            <Tooltip title={HASHTAG_HELPTEXT} >
                                <IconButton aria-label="helptext">
                                    <Help />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                        <Grid item xs={10}>
                            <TextField
                                id="campaignURL"
                                value={values.campaignURL ? values.campaignURL : ''}
                                onChange={onChange}
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                label="Campaign URL"
                                error={errors.campaignURL}
                            />
                        </Grid>
                        <Grid item xs={1} className="tooltip-grid-item">
                            <Tooltip title={CAMPAIGN_URL} >
                                <IconButton aria-label="helptext">
                                    <Help />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}